import { RequiredField } from '../../../utils/components';

import './Input.css';

export const Input = ({
  label,
  value,
  onChange,
  className,
  error,
  required,
  ...props
}) => {
  return (
    <div className='form-input'>
      <label className='form-input__label'>
        {label}
        {required && <RequiredField />}
      </label>
      <input
        className={`form-input__input ${className || ''} ${
          error ? 'form-input__input--error' : ''
        }`}
        value={value}
        onChange={onChange}
        {...props}
      />
      <p className='form-input__error'>{error}</p>
    </div>
  );
};
